import { render, staticRenderFns } from "./CreateTaskTypeModal.vue?vue&type=template&id=0909379f&scoped=true"
import script from "./CreateTaskTypeModal.vue?vue&type=script&lang=js"
export * from "./CreateTaskTypeModal.vue?vue&type=script&lang=js"
import style0 from "./CreateTaskTypeModal.vue?vue&type=style&index=0&id=0909379f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0909379f",
  null
  
)

export default component.exports